import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.2.3/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";






const utilityNamespace = 'breakOut';





const EVENTS = {
  BREAKOUT_INITIALIZED: `BREAKOUT_INIT.${utilityNamespace}`,
};





class BreakOut {




  init() {
    document.body.setAttribute('data-detectedprerender', 'false');
    const breakoutEls = document.querySelectorAll('[data-breakout]');
    if (breakoutEls.length) {
      document.addEventListener('prerender:loadingComplete', () => {
        document.body.setAttribute('data-detectedprerender', 'true');
        for (let i = 0; i < breakoutEls.length; i += 1) {

          const parentEl = breakoutEls[i].parentNode;
          if (
            !parentEl.classList.contains('accordion-panel')
            || !parentEl.classList.contains('active')
          ) {
            breakoutEls[i].click();
          }
        }



        if (typeof startPrerenderCapture === 'function') {
          startPrerenderCapture();
        }
      });
    }
  }





  get EVENTS() {
    return EVENTS;
  }
}





export default new BreakOut();
